<template>
  <div>
    <TaskFilter />
    <BaseCountCard style="margin-top: 18px;" />
    <DevTaskTrend style="margin-top: 18px;" />

  </div>
</template>

<script>
import TaskFilter from './components/TaskFilter.vue';
import BaseCountCard from './components/BaseCountCard.vue';
import DevTaskTrend from './components/DevTaskTrend.vue';

export default {
  components: { TaskFilter, BaseCountCard, DevTaskTrend }
};
</script>

<style lang="less" scoped>

</style>
